var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c('div',[_c('CompanySelect',{attrs:{"qylx":"房企"}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }